import { render, staticRenderFns } from "./AdminConversations.vue?vue&type=template&id=2a2c4172&"
import script from "./AdminConversations.vue?vue&type=script&lang=js&"
export * from "./AdminConversations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports